// Running changelog for the "What's new" modal.
//
// Newest entry first. To announce something new, prepend an object here — the
// modal auto-pops for everyone the first time `changelog[0].id` changes, so the
// id doubles as the announcement version. Keep ids stable once shipped.
export const changelog = [
  {
    id: "2026-06-momentum",
    date: "2026-06-20",
    emoji: "⚡",
    title: "Build your momentum",
    body: "There's a new momentum meter under your hearts. Every correct letter and word builds it up and climbs an XP multiplier, all the way to 3x, so patient, accurate play is worth more and more. Careful though: a single wrong guess shatters it straight back to zero. It carries across your whole run, so string together clean solves, climb the tiers and watch the screen light up. ⚡",
    link: {href: "https://typebot.co/syndles-ooxwugf", label: "Send an idea 💭"},
  },
  {
    id: "2026-06-achievements",
    date: "2026-06-18",
    emoji: "🏆",
    title: "Achievements",
    body: "There's a new trophy icon up top: tap it to see your achievements. Earn them for deep runs, daily streaks, slick puzzle solves and big milestones, with more to come. Already a regular? Plenty will unlock the next time you play. Got a cool achievement idea? We'd love to hear it.",
    link: {href: "https://typebot.co/syndles-ooxwugf", label: "Suggest an achievement 🏆"},
  },
  {
    id: "2026-06-unlimited",
    date: "2026-06-15",
    emoji: "♾️",
    title: "Unlimited puzzles",
    body: "You asked, we listened: by popular request the daily run is now unlimited. There's no fixed number to clear any more, so you can keep going for as long as your hearts hold out. See how far you can get, and how high you can climb the leaderboard. 🚀",
    link: {href: "https://typebot.co/syndles-ooxwugf", label: "Send an idea 💭"},
  },
  {
    id: "2026-06-hints",
    date: "2026-06-11",
    emoji: "💡",
    title: "More hearts, and hints",
    body: "We've been listening: the early puzzles were too punishing, so every run now starts with more hearts. And when you're truly stuck, you can spend a heart on a Hint to reveal a hidden letter. We read every idea you send in, and plenty of them end up shipping. Got one for us?",
    link: {href: "https://typebot.co/syndles-ooxwugf", label: "Send an idea 💭"},
  },
  {
    id: "2026-06-archive",
    date: "2026-06-09",
    emoji: "🗓️",
    title: "Play the archive",
    body: "Missed a day, or just want more? You can now replay past puzzles for practice. Open the leaderboard, page back to any earlier day and tap \"Play this day\" to take on that day's run from scratch. It's purely for fun: archive runs don't count towards your XP, streak or the leaderboard. 🎯",
  },
  {
    id: "2026-06-hearts",
    date: "2026-06-07",
    emoji: "❤️",
    title: "Hearts, and a bolder way to play",
    body: "Lives just got deeper. Your hearts are now a single pool that carries across the whole day instead of resetting each puzzle, starting at 4 and building up to 8. Feeling clever? Type in a whole word and guess it: nail it to bank a heart, miss and it costs you two. ❤️",
  },
  {
    id: "2026-06-dictionary",
    date: "2026-06-06",
    emoji: "📖",
    title: "Look up any word",
    body: "The dictionary is now always at your fingertips: tap the book icon any time to search for any word and read its definition, not just the ones you've uncovered. The words you reveal each game still show up there too. Go and expand your vocabulary! 🤓",
  },
  {
    id: "2026-06-audio",
    date: "2026-06-06",
    emoji: "🔊",
    title: "Sound effects are here",
    body: "The game now has sound: a little chime when you reveal a letter, a softer note when you miss, and a cheerful tune when you finish a puzzle. Not your thing? You can switch sound off any time in Settings. 🎵",
  },
  {
    id: "2026-06-stats",
    date: "2026-06-06",
    emoji: "📊",
    title: "Your stats, leveled up",
    body: "We've given your stats a big glow-up: track your level and XP progress, see your best score and streaks at a glance, and explore your score trend and play calendar. The leaderboard and rankings got a fresh look too, with trophies and your daily position front and centre. Take a look! 🏆",
  },
  {
    id: "2026-06-variety",
    date: "2026-06-05",
    emoji: "✨",
    title: "Fresher puzzles!",
    body: "We've rebuilt the puzzle pool from the ground up: over 3,900 hand-checked synonym sets, with every word verified as a real synonym of the others. That means far more variety and a lot fewer repeats from one day to the next. Enjoy! 🧩",
  },
];
